export default __webpack_public_path__ + "static/media/globe.816eab2b.svg";